import Vue from 'vue'
import Router from 'vue-router'

import {
  STREET, HOUSE, ROBOT, STORE, BLOG, PARTY, HUB, TEST, POLL, DASHBOARD,
} from './services/UserStory'

Vue.use(Router)

function createRouter() {
  return new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
        path: '/',
        name: 'home',
        component: () => import('./views/Home.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: '/lesson/1',
        name: 'lesson1',
        component: () => import('./views/Lesson1/Lesson1.vue'),
        props: { taskNumber: 0, key: 0 },
        meta: { requiresAuth: true, title: STREET.title },
      },
      {
        path: '/lesson/2',
        name: 'lesson2',
        component: () => import('./views/Lesson1/Lesson1.vue'),
        props: { taskNumber: 1, key: 1 },
        meta: { requiresAuth: true, title: HOUSE.title },
      },
      {
        path: '/lesson/3',
        name: 'lesson3',
        component: () => import('./views/Lesson2/Lesson2.vue'),
        meta: { requiresAuth: true, title: ROBOT.title },
      },
      {
        path: '/lesson/4',
        name: 'lesson4',
        component: () => import('./views/Lesson3/Lesson3.vue'),
        props: { taskNumber: 0 },
        meta: { requiresAuth: true, title: STORE.title },
      },
      {
        path: '/lesson/5',
        name: 'lesson5',
        component: () => import('./views/Lesson3/Lesson3.vue'),
        props: { taskNumber: 1 },
        meta: { requiresAuth: true, title: BLOG.title },
      },
      {
        path: '/lesson/6',
        name: 'lesson6',
        component: () => import('./views/Lesson4/Lesson4.vue'),
        meta: { requiresAuth: true, title: PARTY.title },
      },
      {
        path: '/test',
        name: 'test',
        component: () => import('./views/Test/Test.vue'),
        meta: { requiresAuth: true, title: TEST.title },
      },
      {
        path: '/poll',
        name: 'poll',
        component: () => import('./views/Poll/Poll.vue'),
        meta: { requiresAuth: true, title: POLL.title },
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('./views/Dashboard/Dashboard.vue'),
        meta: { requiresAuth: true, title: DASHBOARD.title },
      },
      {
        path: '/hub',
        name: 'hub',
        component: () => import('./views/Hub/Hub.vue'),
        meta: { requiresAuth: true, title: HUB.title },
      },
      {
        path: '/*',
        name: 'home2',
        component: () => import('./views/Home.vue'),
        meta: { requiresAuth: false },
      },
    ],
  })
}

export default createRouter()
